import { render, staticRenderFns } from "./pieRing.vue?vue&type=template&id=379f75be&scoped=true&"
import script from "./pieRing.vue?vue&type=script&lang=js&"
export * from "./pieRing.vue?vue&type=script&lang=js&"
import style0 from "./pieRing.vue?vue&type=style&index=0&id=379f75be&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "379f75be",
  null
  
)

export default component.exports